import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('Controlling');

export const VENDORCOMPANYCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('companyCode', 'Entity.VendorCompanyCode.CompanyCode')
    .required()
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder
    .text('withHoldingTaxCode', 'Entity.VendorCompanyCode.WithHoldingTaxCode')
    .maxLength(2)
    .build(),
  FieldBuilder
    .text('withHoldingTaxType', 'Entity.VendorCompanyCode.WithHoldingTaxType')
    .maxLength(2)
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
];

export const VENDORCOMPANYCODE_CONFIG = {
  entityName: 'VendorCompanyCode',
  localizationKey: 'Controlling::Entity.VendorCompanyCode',
  fields: VENDORCOMPANYCODE_FIELDS,
  permission: 'ControllingContract.VendorCompanyCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
